interface selectData {
  id: number
  option?: string
  disabled: boolean
  selected?: boolean
  gender?: string
}

export const SelectOptions: selectData[] = [
  {
    id: 1,
    option: 'First Bank',
    disabled: true,
    selected: true,
  },
  {
    id: 2,
    option: 'GT Bank',
    disabled: false,
  },
  {
    id: 3,
    option: 'Twitter',
    disabled: false,
  },
  {
    id: 4,
    option: 'A friend',
    disabled: false,
  },
  {
    id: 5,
    option: 'Others',
    disabled: false,
  },
]

export const SelectGender: selectData[] = [
  {
    id: 1,
    gender: 'Select',
    disabled: true,
    selected: true,
  },
  {
    id: 2,
    gender: 'Male',
    disabled: false,
  },
  {
    id: 3,
    gender: 'Female',
    disabled: false,
  },
]

export const SelectFrequency: selectData[] = [
  {
    id: 1,
    option: 'Select',
    disabled: true,
    selected: true,
  },
  {
    id: 2,
    option: 'daily',
    disabled: false,
  },
  {
    id: 3,
    option: 'weekly',
    disabled: false,
  },
  {
    id: 4,
    option: 'monthly',
    disabled: false,
  },
]
export const SelectRelationship: selectData[] = [
  {
    id: 1,
    option: 'Select',
    disabled: true,
    selected: true,
  },
  {
    id: 2,
    option: 'Father',
    disabled: false,
  },
  {
    id: 3,
    option: 'Mother',
    disabled: false,
  },
  {
    id: 4,
    option: 'friend',
    disabled: false,
  },
  {
    id: 5,
    option: 'Sister',
    disabled: false,
  },
  {
    id: 6,
    option: 'Brother',
    disabled: false,
  },
  {
    id: 7,
    option: 'Husband',
    disabled: false,
  },
  {
    id: 8,
    option: 'Wife',
    disabled: false,
  },
]
